import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

const StockItemDetails = () => {
  const [stockData, setStockData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useEffect(() => {
    const fetchStockDetails = async () => {
      try {
        const response = await axios.get(
          `https://www.nissi-india.com/api/itemDetails_stockRpt`,
          { params: { id } }
        );
        setStockData(response.data.items || []);
        console.log("response:", response.data);
      } catch (err) {
        setError("Failed to fetch stock details.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchStockDetails();
    }
  }, [id]);

  if (loading) return <p className="p-4">Loading...</p>;
  if (error) return <p className="p-4 text-red-600">{error}</p>;

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-2">Item Stock Details</h2>
      <table className="w-full border-collapse border border-gray-400 text-sm">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-400 px-2 py-1">Item Code</th>
            <th className="border border-gray-400 px-2 py-1">Item Name</th>
            <th className="border border-gray-400 px-2 py-1">Category</th>
            <th className="border border-gray-400 px-2 py-1">Sub Category</th>
            <th className="border border-gray-400 px-2 py-1">Inner Sub Category</th>
            <th className="border border-gray-400 px-2 py-1">Deep Inner Sub Category</th>
          </tr>
        </thead>
        <tbody>
          {stockData.length > 0 ? (
            stockData.map((row, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="border border-gray-400 px-2 py-1">{row.fld_itemcode}</td>
                <td className="border border-gray-400 px-2 py-1">{row.fld_itemname}</td>
                <td className="border border-gray-400 px-2 py-1">{row.fld_itemcategory_name}</td>
                <td className="border border-gray-400 px-2 py-1">{row.fld_itemsubCategoryName}</td>
                <td className="border border-gray-400 px-2 py-1">{row.fld_innersubCategoryName}</td>
                <td className="border border-gray-400 px-2 py-1">{row.fld_deepinnersubCategoryName}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center p-2">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StockItemDetails;
